import { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import logo from './gonkville.png';
import author from './author.png';
// import videowebm from './lease.webm';
import videomp4 from './lease-noaudio.mp4';
import wood from './wood2.png';
import book from './books.png';
import book1 from './book1.png';
import book2 from './book2.png';
import book3 from './book3.png';
import ue5 from './UE5.png';
import gusImage from "./renders/Gus.png";
import stigImage from "./renders/Stig.png";
import daleImage from "./renders/Dale.png";
import oakenImage from "./renders/Oaken.png";
import helgaImage from "./renders/Helga.png";
import trollImage from "./renders/Troll.png";
import mamaImage from "./renders/Mama.png";
import elfImage from "./renders/Elf.png";
import papaImage from "./renders/Papa.png";
import sigridImage from "./renders/Sigrid.png";
import draugrImage from "./renders/Draugr.png";
import jotunnImage from "./renders/Jotunn.png";
import characters from './characters.png';
import library from './bookshelf2.png';
import kitchen from './kitchen.png';
import dream from './dream.png'
import Icon from './Icon';
import Carousel from './Carousel';
import Burger from './Burger';
import Loader from './Loader';
import NavigationLoader from './NavigationLoader';
import { LoaderProvider } from './LoaderContext';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

const carouselBlocks = [
  {
    id: 'books',
    header: 'Read the Books',
    image: book,
    alt: 'Books 1-3 of the Gonkville series',
    blurb: 'Join Gus on his various adventures from defending the family farm to skiing through a haunted forest.',
    buttonText: 'Learn More',
    buttonHref: '/books',
  },
  {
    id: 'blog',
    header: 'Visit the Blog',
    image: ue5,
    alt: 'A hammer and the UE5 logo',
    blurb: 'Stay up-to-date on the happenings in Gonkville by reading Author Jack Bittner\'s blog.',
    buttonText: 'Learn More',
    buttonHref: '/blog',
  },
  {
    id: 'characters',
    header: 'Meet the Characters',
    image: characters,
    alt: 'The main characters of Gonkville',
    blurb: 'Visit Gonkville and meet the townspeople, animals and monsters that live in this magical place.',
    buttonText: 'Learn More',
    buttonHref: '/characters',
  },
];

function Home() {
  const [videoFade, setVideoFade] = useState(0);

  useEffect(() => {
    let ticking = false;
    const updateFade = () => {
      setVideoFade(Math.min(1, Math.max(0, window.scrollY / window.innerHeight)));
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateFade);
      }
    };
    updateFade();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div>
      <div className="video-container" id="home">
        <div className="video-overlay">
          <div className="gonkville-container">
            <img className="gonkville-logo" src={logo} alt="Gonkville Logo" />
            <p className="gonkville-subtitle">A World of Gnomes and Magic</p>
          </div>
        </div>
        <video autoPlay muted playsInline loop aria-label="A collage of photos from the Gonkville books">
          {/* <source src={videowebm} type="video/webm"/> */}
          <source src={videomp4} type="video/mp4"/>
        </video>
        <div className="video-fade-overlay" style={{ opacity: videoFade }}></div>
      </div>
      <div className="pages-container" id="books" style={{ backgroundImage: `url("${wood}")` }}>
        <Carousel items={carouselBlocks} />
      </div>
      <div className="about-container" id="about">
        <div className="about-overlay">
          <div className="about-section">
            <div className="about-section-text">
              <h2>About the Author</h2>
              <p>Jack Bittner, the creator of Gonkville, lives on a hobby
                farm in Wisconsin with his wife Kalli. At his farm, there
                are many animals including chickens, cats and dogs. Ever since 
                he was a child, he loved drawing pictures and writing comic books about his friends.
                Over the years, he added digital art, 3D animation and coding
                to his toolbelt. After college, he pursued a career in
                marketing but felt as if God was calling him to use these skills
                in a more impactful way. In 2024, he started writing Gonkville
                books because he felt like there was a void in meaningful children’s
                entertainment.
                <br />
                <br />
                Creating Gonkville books and cartoons is just one
                of the many projects Jack is involved in. He is currently involved
                in the creation of a Gonkville video game and a comic book series
                entitled “Midguardians” inspired by Norse mythology. He is also
                involved in his local church and plays bass on the worship team.
                In his free time, he enjoys taking his Great Pyrenees on walks through the
                woods.</p>
                <p>You can learn more about Jack by visiting his personal website: <a target="_blank" href="https://megabitt.net/">megabitt.net</a></p>
            </div>
            <div className="about-section-image">
              <img src={author} alt="Photo of Jack Bittner" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function Books() {
  const books = [
    {
      title: 'Book 1: Gus Becomes a Warrior', 
      image: book1, 
      stats: '48 pages | Illustrated | Ages 8+', 
      description: 'In the first book, Gus learns that being a viking warrior isn\'t as glorious as he thought it would be.  Join Gus and Uncle Stig as they take care of the family farm while Papa is off fighting trolls.', 
      link: "https://www.amazon.com/Becomes-Warrior-Gonkville-Jack-Bittner/dp/B0DFBSJJZ2"
    },
    {
      title: 'Book 2: Gus Learns How to Ski', 
      image: book2, 
      stats: '48 pages | Illustrated | Ages 8+', 
      description: 'This book journals Gus\' adventure on the slopes with Papa. When he takes a wrong turn, he meets an ice giant and discovers the true meaning of Christmas.  Join Gus as he navigates the twists and turns of learning how to ski.',
      link: "https://www.amazon.com/Gus-Learns-How-Ski-Gonkville/dp/B0DNQ66H3Y"
    },
    {
      title: 'Book 3: Gus Makes a New Friend', 
      image: book3, 
      stats: '48 pages | Illustrated | Ages 8+', 
      description: 'When a magical species of horses responsible for the seasons is near extinct, Gus rescues the last one from a band of evil elves.  Join Gus as he makes a new friend and saves Gonkville from a forever winter at the same time.',
      link: "https://www.amazon.com/-/es/Gus-Makes-New-Friend-Gonkville/dp/B0F2GD832B"
    },
  ]
  return (
    <div>
      <div className="books-container" id="books" style={{ backgroundImage: `url("${library}")` }}>
        <div className="books-overlay">
          <div className="books-header">
            <h1>Books</h1>
          </div>
          {books.map((book, index) => (
            <div className="books-card" key={index}>
              <h3>{book.title}</h3>
              <div className="books-card-body">
                <img src={book.image} alt={book.title} />
                <div className="books-card-text">
                  <p className="books-card-stats">{book.stats}</p>
                  <p className="books-card-description">{book.description}</p>
                  <a className="carousel-card-button" href={book.link}>
                    View on Amazon
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const blogPostContext = require.context('./blog', false, /\.html$/);
const blogPosts = blogPostContext.keys().map((key) => ({
  key,
  html: blogPostContext(key).default,
}));

function Blog() {
  return (
    <div>
      <div className="blog-container" id="blog" style={{ backgroundImage: `url("${kitchen}")` }}>
        <div className="blog-overlay">
          <div className="blog-header">
            <h1>Blog</h1>
          </div>
          {blogPosts.map((post) => (
            <div
              className="blog-post"
              key={post.key}
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.html) }}
            >
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function Characters() {
  const characterArray = [
    {
      name: "Gus",
      icon: "",
      image: gusImage,
      bio: "Gus is a spirited young lad that lives in the town of Gonkville. Like many boys his age, he's intrigued by war and warriors.  You can find him down by the pond almost in any season for he loves to skate and swim.  He’s outdoors so much that his family only sees him in the morning and at suppertime.<br/><br/>  Everyone who knows him knows that his best friend is Dale the Dala Horse.  They met through extraordinary circumstances but that is another story for another time.  Gus dreams of one day becoming a warrior just like his father.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Skiing, Horseback Riding and Heroic Legends",
        "Monsters, Roosters and Sitting Still"
      ]
    },
    {
      name: "Sigrid",
      icon: "",
      image: sigridImage,
      bio: "Sigrid is a curious little girl who lives in the town of Gonkville.  She may be little but she is very intelligent for her age and eager to learn about new things.  When she’s not helping Mama in the kitchen, she loves taking care of the animals on the farm.  <br/> <br/>Sigrid counts every chicken every day to make sure they all get safely back into the coop.  She looks up to her older brother, Gus, and wishes he would take her on more of his adventures.",
      stats: [
        "<a href='/books'>Gus Makes a New Friend</a>",
        "Skating, Baking and Kitties",
        "Thunderstorms, Insects and Sharing"
      ]
    },
    {
      name: "Mama",
      icon: "",
      image: mamaImage,
      bio: "Gus and Sigrid have an amazing mother.  She loves to cook and bake all kinds of wonderful food.  She practically invented lefse and she renowned for her pumpkin pie recipe.  <br/> <br/> When she isn’t overloaded with her two rambunctious children, she likes to tend to her garden or practice archery.  Her aim is deadly and when her family is threatened, this mama becomes a mama bear.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Cooking, Archery and Market Deals",
        "Mondays, Elves and Doing Laundry"
      ]
    },
    {
      name: "Papa",
      icon: "",
      image: papaImage,
      bio: "Papa is an amazing dad to two amazing children: Gus and Sigrid.  When he’s not out protecting Gonkville with Chief Oaken, he’s at home working on the farm and doing his best to make Mama’s life less overwhelming.  <br/> <br/> His approach to parenting is gentle but firm.  While he values victory, what he wants more than anything is for his kids to grow even if that means allowing his kids to fail.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Farming, Reading and Well-Crafted Blades",
        "Jotunns, Trolls and Being Away From Family"
      ]
    },
    {
      name: "Dale",
      icon: "",
      image: daleImage,
      bio: "Dale is one of the last Dala Horses on Earth.  The Dala Horses are a magical race of creatures that bring about spring when they wake up from their winter hibernation.  But you can read more about them in <a href='/books'>Gus Makes a New Friend</a>.  <br/> <br/>Dale, specifically, is Gus’ best friend because Gus saved him from elves.  Nowadays, he helps out on the family farm.  When it is time for winter to be over, he runs and romps throughout Gonkville to make it spring again.",
      stats: [
        "<a href='/books'>Gus Makes a New Friend</a>",
        "Freedom, Springtime and Good Snacks",
        "Elves"
      ]
    },
    {
      name: "Uncle Stig",
      icon: "",
      image: stigImage,
      bio: "Uncle Stig is Papa’s older brother and a retired warrior.  He fought alongside Chief Oaken for many years and grew tired of the constant fighting.  Once he had served Gonkville well, he quit his job and became a full time farmer.  <br/> <br/>You can almost always find him gardening, tending to his animals or helping out at Papa’s farm.  Nothing raises his spirits more than spending time in nature and being alone with his thoughts.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Trees, Gardening and Animals",
        "Elves, Loud Noises and Children Who Don't Listen"
      ]
    },
    {
      name: "Chief Oaken",
      icon: "",
      image: oakenImage,
      bio: "Chief Oaken is an old warrior and a man of the people.  When he was selected to be the leader of Gonkville, he swore to defend the village with his life.  Oaken has a lot of energy for his age.  <br/> <br/>He has fended off attacks from many monsters.  He and his Vikings have banished many a threat back to the depths from which they came.  When this Chief has his warriors behind him, he cannot be stopped.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Gonkville, Safety and A Good Fire",
        "Anything that threatens Gonkville"
      ]
    },
    {
      name: "Healer Helga",
      icon: "",
      image: helgaImage,
      bio: "Helga is the village doctor.  She can deliver babies, set broken bones and even cure chicken pox.  Through the use of magic potions, she can cure diseases.  Nobody knows exactly how she does it but whenever there is an outbreak in the village, the people of Gonkville know who to turn to.  <br/> <br/>Her apothecary shop is equipped with beds and bandages in addition to potions.  Some consider her a bit crazy but there is no one as caring as Healer Helga.",
      stats: [
        "<a href='/books'>Gus Makes a New Friend</a>",
        "Puzzles, Potions and Helping People",
        "Elves, Elves and More Elves"
      ]
    },
    {
      name: "Elves",
      icon: "",
      image: elfImage,
      bio: "Elves are little cretins that thrive in chaos.  They love to hurt, steal and break things.  These mischievous imps are so fast that it is nearly impossible to catch them.  <br/> <br/>If there’s one thing that the elves hate, it’s Dala Horses.  They have hunted these horses to near extinction and have done so for one reason: the Dala Horses bring about spring.  Elves hate the warm months and wish it could be always winter and never Christmas.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Mischief, Mayhem, Chaos",
        "Dala Horses, Springtime, Joy"
      ]
    },
    {
      name: "Trolls",
      icon: "",
      image: trollImage,
      bio: "There's not a lot to say about trolls.  They are massive, grumpy monsters that hate everyone and everything.  This normally includes elves but they will occasionally ally with them if it means they get to pillage a village.  <br/> <br/> Trolls come from all sorts of places: forests, mountains and under bridges.  They may be slow but they carry logs as weapons and throw boulders at their foes.",
      stats: [
        "<a href='/books'>Gus Becomes a Warrior</a>",
        "Nothing",
        "Everything"
      ]
    },
    {
      name: "Jotunns",
      icon: "",
      image: jotunnImage,
      bio: "Long ago, the frost giants terrorized the village of Gonkville.  It wasn’t until a heroic chieftain stood up to them that they went away.  But you can read all about that in <a href='/books'>Gus Learns How to Ski</a>. <br/> <br/>  Nowadays, Jotunns hide in caves.  That being said, travelers who venture too far into the woods might run into one if they aren’t careful.  Jotunns may be rare but they are some of the most dangerous monsters on the whole continent.",
      stats: [
        "<a href='/books'>Gus Learns How to Ski</a>",
        "Cold Weather, Raw Meat, Caves",
        "The people of Gonkville"
      ]
    },
    {
      name: "Draugrs",
      icon: "",
      image: draugrImage,
      bio: "Draugrs are monsters that are neither dead nor alive.  These skeleton creatures roam the woods at night and prey upon unarmed travelers.  <br/> <br/> \“Why do they look like zombies?\” one may ask.  Many Draugrs are warriors that were cursed to live unnaturally long lives due to greed and selfishness.  While they may look pretty spooky, they are actually pretty easy to defeat.  Since they’re just a pile of bones, a swift kick in the right place will send them flying apart.",
      stats: [
        "Not yet published",
        "Nighttime, Campfire Stories, Spooking Travelers",
        "Curses, Dogs, Bravery"
      ]
    }
  ]
  let [charState, setCharState] = useState(characterArray[0]);
  return (
    <div>
      <div className="characters-container" id="characters" style={{ backgroundImage: `url("${dream}")` }}>
        <div className="characters-overlay">
          <div className="characters-header">
            <h1>Characters</h1>
          </div>
          <div className="icon-container">

            <div className="icon-wrapper">
              {characterArray.map((character, index) => (
                <Icon character={character.name} setCharState={() => setCharState(characterArray[index])} />
              ))}
            </div>
          </div>
          <div className="character-card" id="bio">
            <h2>{charState.name}</h2>
            <div className="character-card-body">
              <img className="character-card-image" src={charState.image} alt={charState.name} />
              <div className="character-card-text">
                <div className="character-card-stats">
                  <p><span className="character-card-stats-prefix">First Appearance: </span><span dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(charState.stats[0])}` }}></span></p>
                  <p><span className="character-card-stats-prefix">Likes: </span>{charState.stats[1]}</p>
                  <p><span className="character-card-stats-prefix">Dislikes: </span>{charState.stats[2]}</p>
                </div>
                <p className="character-card-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(charState.bio) }}></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function App() {

  return (
    <LoaderProvider>
    <BrowserRouter>
      <Loader />
      <NavigationLoader />
      <Burger />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/books" element={<Books />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/characters" element={<Characters />} />
      </Routes>
      <div className="footer-container" id="contact" style={{ backgroundImage: `url("${wood}")` }}>
        <div className="footer-overlay">
          <p>© 2026 Jack Bittner</p>
          <div className="footer-icons">
            <a href="https://www.tiktok.com/@hellogonkville" target="_blank" style={{ marginTop: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="1 2 21 21">
              <path d="M21,2H3A1,1,0,0,0,2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2Zm-3.281,8.725h0c-.109.011-.219.016-.328.017A3.571,3.571,0,0,1,14.4,9.129v5.493a4.061,4.061,0,1,1-4.06-4.06c.085,0,.167.008.251.013v2a2.067,2.067,0,1,0-.251,4.119A2.123,2.123,0,0,0,12.5,14.649l.02-9.331h1.914A3.564,3.564,0,0,0,17.719,8.5Z" />
            </svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61564165856254" target="_blank" style={{ marginTop: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-143 145 500 500">
              <path d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z   M169.5,357.6l-2.9,38.3h-39.3v133H77.7v-133H51.2v-38.3h26.5v-25.7c0-11.3,0.3-28.8,8.5-39.7c8.7-11.5,20.6-19.3,41.1-19.3  c33.4,0,47.4,4.8,47.4,4.8l-6.6,39.2c0,0-11-3.2-21.3-3.2c-10.3,0-19.5,3.7-19.5,14v29.9H169.5z" />
            </svg>
            </a>
            <a href="https://www.youtube.com/@HelloGonkville" target="_blank" style={{ marginTop: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-143 145 512 512">
              <g>
                <polygon points="78.9,450.3 162.7,401.1 78.9,351.9  " />
                <path d="M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z    M241,446.8L241,446.8c0,44.1-44.1,44.1-44.1,44.1H29.1c-44.1,0-44.1-44.1-44.1-44.1v-91.5c0-44.1,44.1-44.1,44.1-44.1h167.8   c44.1,0,44.1,44.1,44.1,44.1V446.8z" />
              </g>
            </svg>
            </a>
            <a href="https://www.instagram.com/gonkville/" target="_blank" style={{ marginTop: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M14.667 12c0 1.473-1.194 2.667-2.667 2.667-1.473 0-2.667-1.193-2.667-2.667 0-1.473 1.194-2.667 2.667-2.667 1.473 0 2.667 1.194 2.667 2.667zm3.846-3.232c.038.843.046 1.096.046 3.232s-.008 2.389-.046 3.233c-.1 2.15-1.109 3.181-3.279 3.279-.844.038-1.097.047-3.234.047-2.136 0-2.39-.008-3.232-.046-2.174-.099-3.181-1.132-3.279-3.279-.039-.845-.048-1.098-.048-3.234s.009-2.389.047-3.232c.099-2.152 1.109-3.181 3.279-3.279.844-.039 1.097-.047 3.233-.047s2.39.008 3.233.046c2.168.099 3.18 1.128 3.28 3.28zm-2.405 3.232c0-2.269-1.84-4.108-4.108-4.108-2.269 0-4.108 1.839-4.108 4.108 0 2.269 1.84 4.108 4.108 4.108 2.269 0 4.108-1.839 4.108-4.108zm1.122-4.27c0-.53-.43-.96-.96-.96s-.96.43-.96.96.43.96.96.96c.531 0 .96-.43.96-.96zm6.77-7.73v24h-24v-24h24zm-4 12c0-2.172-.009-2.445-.048-3.298-.131-2.902-1.745-4.52-4.653-4.653-.854-.04-1.126-.049-3.299-.049s-2.444.009-3.298.048c-2.906.133-4.52 1.745-4.654 4.653-.039.854-.048 1.127-.048 3.299 0 2.173.009 2.445.048 3.298.134 2.906 1.746 4.521 4.654 4.654.854.039 1.125.048 3.298.048s2.445-.009 3.299-.048c2.902-.133 4.522-1.745 4.653-4.654.039-.853.048-1.125.048-3.298z" />
            </svg>
            </a>
          </div>
        </div>
      </div>
    </BrowserRouter>
    </LoaderProvider>
  );
}

export default App;
